import script from "./QuizDrawerPlayPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./QuizDrawerPlayPanel.vue?vue&type=script&setup=true&lang=ts"

import "./QuizDrawerPlayPanel.vue?vue&type=style&index=0&id=e6aabb3e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e6aabb3e"]])

export default __exports__